import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/extraPayments';

import { accept } from './utils';

export default function* listenAccept() {
  yield takeEvery(actions.accept.type, accept);
}
